// extracted by mini-css-extract-plugin
module.exports = {"spinner":"_1m1lRg4GGK_MOJrHxbhMR_","sk-bouncedelay":"_66miEpIlYRg2SRmowACZv","bounce1":"_2kVv8lc0veWgj1YWSjU0u4","bounce2":"_2JOGZConkC-_tNslBXqnFK"};